import { Typography, Row, Col, Card, Avatar, Space, Tag, Button, Grid } from "antd";
import { GithubOutlined, LinkedinOutlined, MailOutlined } from "@ant-design/icons";
import { sendGAEvent } from "../../utils";

const { Title, Paragraph, Text } = Typography;

const handleContactClick = (platform: string, url: string) => {
  sendGAEvent('contact_click', {
    event_category: 'engagement',
    event_label: platform,
    platform
  });
  window.open(url, '_blank');
};

const frontendSkills = [
  'React', 'TypeScript', 'Next.js', 'Redux', 'HTML/CSS', 'Responsive Design'
];

const cloudDevOpsSkills = [
  'AWS', 'Cloud Computing', 'CI/CD',
];

const backendSkills = [
  'Node.js', 'NestJS', 'Express', 'REST APIs', 'GraphQL', 'Microservices'
];

const { useBreakpoint } = Grid;

const Perfil = () => {
  const screens = useBreakpoint();

  return (
    <main style={{
      paddingTop: screens.md ? '80px' : '0',
      paddingLeft: 0,
      paddingRight: 0,
      minHeight: '100vh'
    }}>
      <Row justify="center">
        <Col xs={24} sm={22} md={20} lg={16} xl={14}>
          <Card
            style={{
              border: 'none',
            }}
          >
            <Row gutter={[24, 24]} align="middle">
              <Col xs={24} sm={8} md={6}>
                <div style={{ textAlign: 'center' }}>
                  <Avatar
                    size={120}
                    src="/images/foto-perfil-01.png"
                    alt="Silvano Amaral"
                    style={{
                      border: '1px solid #1e40af',
                      boxShadow: '0 4px 16px rgba(30, 64, 175, 0.3)'
                    }}
                  />
                </div>
              </Col>

              <Col xs={24} sm={16} md={18}>
                <Title level={1} style={{ color: '#1f2937' }}>
                  Silvano Amaral
                </Title>
                <Title level={3} style={{
                  color: '#1e40af',
                  fontWeight: 500,
                  marginBottom: '16px'
                }}>
                  Staff Engineer & Arquiteto Frontend
                </Title>
              </Col>
            </Row>

            {/* Descrição Principal */}
            <section>
              <Paragraph style={{
                fontSize: '18px',
                lineHeight: '1.7',
                color: '#1f2937',
                marginBottom: '24px'
              }}>
                <strong>Transformo ideias em soluções digitais de alta performance.</strong> Com mais de{' '}
                <Text strong style={{ color: '#1e40af' }}>10 anos de experiência</Text> liderando
                projetos de grande escala, especializo-me em arquiteturas frontend que{' '}
                <Text strong>reduzem custos, aumentam conversões e escalam com o crescimento do negócio</Text>.
              </Paragraph>

              <Paragraph style={{
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#4b5563',
                marginBottom: '24px'
              }}>
                Atualmente como <Text strong>Frontend Developer no Grupo Boticário</Text>,
                combino conhecimento técnico profundo com visão estratégica de produto,
                entregando soluções que impactam diretamente os resultados de negócio.
              </Paragraph>

              <Paragraph style={{
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#4b5563'
              }}>
                <Text strong>Minha missão:</Text> Ajudar empresas a acelerar sua transformação digital
                através de arquiteturas modernas, equipes de alta performance e processos otimizados
                que geram valor mensurável.
              </Paragraph>
            </section>

            {/* Especialidades */}
            <section style={{ marginTop: '40px' }}>
              <Title level={3} style={{ color: '#1f2937', marginBottom: '24px' }}>
                Especialidades Técnicas
              </Title>

              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Text strong style={{ color: '#1e40af', fontSize: '16px' }}>
                    Frontend & Arquitetura:
                  </Text>
                  <div style={{ marginTop: '8px' }}>
                    {frontendSkills.map(skill => (
                      <Tag
                        key={skill}
                        style={{
                          margin: '4px 8px 4px 0',
                          padding: '4px 12px',
                          borderRadius: '6px',
                          backgroundColor: '#eff6ff',
                          border: '1px solid #bfdbfe',
                          color: '#1d4ed8'
                        }}
                      >
                        {skill}
                      </Tag>
                    ))}
                  </div>
                </Col>

                <Col span={24}>
                  <Text strong style={{ color: '#1e40af', fontSize: '16px' }}>
                    Cloud & DevOps:
                  </Text>
                  <div style={{ marginTop: '8px' }}>
                    {cloudDevOpsSkills.map(skill => (
                      <Tag
                        key={skill}
                        style={{
                          margin: '4px 8px 4px 0',
                          padding: '4px 12px',
                          borderRadius: '6px',
                          backgroundColor: '#fff7ed',
                          border: '1px solid #fed7aa',
                          color: '#c2410c'
                        }}
                      >
                        {skill}
                      </Tag>
                    ))}
                  </div>
                </Col>

                <Col span={24}>
                  <Text strong style={{ color: '#1e40af', fontSize: '16px' }}>
                    Backend & APIs:
                  </Text>
                  <div style={{ marginTop: '8px' }}>
                    {backendSkills.map(skill => (
                      <Tag
                        key={skill}
                        style={{
                          margin: '4px 8px 4px 0',
                          padding: '4px 12px',
                          borderRadius: '6px',
                          backgroundColor: '#f0fdf4',
                          border: '1px solid #bbf7d0',
                          color: '#166534'
                        }}
                      >
                        {skill}
                      </Tag>
                    ))}
                  </div>
                </Col>
              </Row>
            </section>

            {/* Contatos */}
            <section style={{ marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #f0f0f0' }}>
              <Title level={4} style={{ color: '#1f2937', marginBottom: '16px' }}>
                Vamos nos conectar?
              </Title>

              <Space size="large" wrap>
                <Button
                  type="text"
                  icon={<GithubOutlined />}
                  size="large"
                  style={{ color: '#333' }}
                  onClick={() => handleContactClick('github', 'https://github.com/silvanoamaral')}
                >
                  GitHub
                </Button>

                <Button
                  type="text"
                  icon={<LinkedinOutlined />}
                  size="large"
                  style={{ color: '#0077b5' }}
                  onClick={() => handleContactClick('linkedin', 'https://www.linkedin.com/in/silvano-amaral/')}
                >
                  LinkedIn
                </Button>

                <Button
                  type="text"
                  icon={<MailOutlined />}
                  size="large"
                  style={{ color: '#1e40af' }}
                  onClick={() => handleContactClick('email', 'mailto:silvano.dev9@gmail.com')}
                >
                  E-mail
                </Button>
              </Space>
            </section>
          </Card>
        </Col>
      </Row>
    </main>
  );
};

export default Perfil;